<div class="overlay">
  <div class="overlay-content z-3">
    <svg class="google-style-spinner" viewBox="25 25 50 50">
      <!-- Background Ring -->
      <circle class="spinner-bg" cx="50" cy="50" r="20" fill="none" stroke-width="5"/>

      <!-- Foreground Animated Arc -->
      <circle class="spinner-path" cx="50" cy="50" r="20" fill="none" stroke-width="5"/>
    </svg>
  </div>
</div>
